import React from 'react';
import i18n from '../../Shared/Translation/i18n';
import ListView from '../../Shared/ListView';
import { COLUMN_TYPE } from '../../Shared/ListView/helper';
import { ApiUrl } from '../../project/Defines.js';
import { EVENT_NAME } from '../../project/utilities';
import { PopupClasses, PopupTypes } from '../../components/Popup';

export default function Links(props) {
    const isThercodim = props.isThercodim;

    const columns = [
        {
            text: 'text.name',
            field: 'name',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.url',
            field: 'url',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.description',
            field: 'description',
            type: COLUMN_TYPE.TEXT
        },
        {
            type: COLUMN_TYPE.ACTION
        }
    ];

    return (
        <div className="section_group">
            <div className="sections extra">
                <div className="form_fields">
                    <div className="section_title"><text>{i18n('text.links')}</text></div>
                    <div className="form_separator"></div>
                </div>
                <ListView
                    columnConfig={columns}
                    apiUrl={isThercodim ? ApiUrl.ThercodimLinksList : ApiUrl.LinksList}
                    deleteUrl={isThercodim ? ApiUrl.ThercodimLinksDelete : ApiUrl.LinksDelete}
                    detailProps={{
                        fullScreen: false,
                        popupType: isThercodim ? PopupTypes.ThercodimLinks : PopupTypes.AquamedLinks,
                        className: PopupClasses.Medium,
                        windowKey: isThercodim ? 'wndThercodimLinksDetail' : 'wndAquamedLinksDetail'
                    }}
                    listUpdateEvent={isThercodim ? EVENT_NAME.THERCODIM_LINKS_LIST_UPDATE : EVENT_NAME.LINKS_LIST_UPDATE}
                    nameField='name'
                    isSimple
                />
            </div>
        </div>
    );
}
